import { createAction } from 'react-async-client';
import {
    CHANGE_CALENDAR_PERIOD,
    CHANGE_CALENDAR_TASK_VIEW
 } from 'constants/actionTypes.js';

export const changeCalendarPeriod = createAction(CHANGE_CALENDAR_PERIOD);
export const changeCalendarTaskView = createAction(CHANGE_CALENDAR_TASK_VIEW);
